/**
 * @module ol/ViewProperty
 */

/**
 * @enum {string}
 */
export default {
  CENTER: 'center',
  RESOLUTION: 'resolution',
  ROTATION: 'rotation'
};

//# sourceMappingURL=ViewProperty.js.map


//////////////////
// WEBPACK FOOTER
// /srv/scratch/old-home/dyall/trinity/trinity-frontend-master/~/ol/ViewProperty.js
// module id = ../../../../ol/ViewProperty.js
// module chunks = 3